import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=006c441b&scoped=true"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"
import style0 from "./FileField.vue?vue&type=style&index=0&id=006c441b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c441b",
  null
  
)

export default component.exports